(function () {
  'use strict';

  angular
    .module('utils.filereader')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('filereader', {
        url: '/filereader',
        templateUrl: 'utils/filereader/filereader.tpl.html',
        controller: 'FilereaderCtrl',
        controllerAs: 'filereader'
      });
  }
}());
